import jwt from '@/auth/jwt/useJwt'
import { computed, ref } from '@vue/composition-api'

export default function Organizations() {
  const route = 'organizations'
  const organization = ref({})
  const formattedOrganization = computed(() => ({
    name: organization.value.name,
    image: organization.value.image?.id,
    country_id: organization.value.country?.id,
    currency_id: organization.value.currency?.id,
  }))

  const getOrganizationsRequest = params => jwt.axiosIns.get(route, { params }).then(res => res).catch(() => [])

  const getOrganizationRequest = (id, params) => jwt.axiosIns.get(`${route}/${id}`, { params }).then(res => res).catch(() => [])

  const addOrganizationRequest = () => jwt.axiosIns.post(route, formattedOrganization.value).then(res => res)

  const updateOrganizationRequest = () => jwt.axiosIns.put(`${route}/${organization.value.id}`, formattedOrganization.value).then(res => res)

  const deleteOrganizationRequest = id => jwt.axiosIns.delete(`${route}/${id}`).then(res => res)

  return {
    organization, getOrganizationsRequest, getOrganizationRequest, addOrganizationRequest, updateOrganizationRequest, deleteOrganizationRequest,
  }
}
